import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { DocumentNumber } from '../document-numbering.models';
import { TranslatorService } from 'src/app/core/translator.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { DocumentNumberingService } from 'src/app/inside-layout/routes/document-numbering/document-numbering.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-document-numbering-form',
  templateUrl: './document-numbering-form.component.html',
  styleUrls: ['./document-numbering-form.component.scss']
})
export class DocumentNumberingFormComponent extends BaseFormComponent  implements OnInit {
  public documentTypes: ValueLabel[] = [];
  public tabs: string[] = ['EXAMPLE'];
  public example: string = 'EXAMPLE';

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    private documentNumberingService: DocumentNumberingService,
    private translateService : TranslateService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/document-numbering-configurations`;
    this.prepareLookupData();
    this.prepareFormData(new DocumentNumber(), (response: DocumentNumber) => {
      return this.modifyResponse(response);
    });
  }
  
  prepareLookupData() {
    this.documentNumberingService.getTypes((response) => {
        for(let i = 0; i < response.length; i++) {
          let value = new ValueLabel();
          this.translateService.get('DOCUMENT_TYPE.' + response[i]).subscribe((translation: string) => {
            value.label = translation;
          });
        
          value.value = response[i];

          this.documentTypes.push(value);
        }
    });
  }
  public codeToUpper(): void {
    if(this.formData != null && this.formData.prefix != null)
        this.formData.prefix = this.formData.prefix.toUpperCase();

    this.constructPrefix();
  }

  constructPrefix() {
    if(this.formData)
      this.example = `${this.formData.prefix == '' ? '0' : this.formData.prefix}${this.formData.usesYear == true ? '-'+new Date().getFullYear() : ''}-00000001`;
  }
}
